"use client"

import { useEffect } from "react"
import { playFocus, playTap } from "@/lib/ui-sound"

// Page-wide click sounds, attached while the calling page is mounted.
//
// Delegated at the document (capture) rather than wired button by button, so
// the chips, the header pills, the price dropdown's items (which render in a
// portal outside the page tree) and the closing CTAs all get the same tick
// without each one importing anything. Clicks anywhere that isn't a control
// stay silent.
//
//   pointerdown inside a text input → focus pop (fires on the gesture, so the
//     page's autoFocus on load stays silent — no gesture, no sound)
//   click on a button / link / menu item → tap tick
//
// Both listeners run inside the user's own gesture, which is what lets the
// AudioContext start on iOS.
const CONTROL = "button, a[href], [role='button'], [role='menuitem'], [role='option']"

export function useUiSounds() {
  useEffect(() => {
    const onPointerDown = (e: PointerEvent) => {
      const t = e.target
      if (!(t instanceof Element)) return
      if (t.closest("input[type='text'], input:not([type]), input[type='search'], textarea")) playFocus()
    }
    const onClick = (e: MouseEvent) => {
      const t = e.target
      if (!(t instanceof Element)) return
      const el = t.closest(CONTROL)
      if (!el || (el as HTMLButtonElement).disabled) return
      playTap()
    }
    document.addEventListener("pointerdown", onPointerDown, true)
    document.addEventListener("click", onClick, true)
    return () => {
      document.removeEventListener("pointerdown", onPointerDown, true)
      document.removeEventListener("click", onClick, true)
    }
  }, [])
}
